import { render, staticRenderFns } from "./TheListPagination.vue?vue&type=template&id=5b85d6dd&scoped=true&"
import script from "./TheListPagination.vue?vue&type=script&lang=js&"
export * from "./TheListPagination.vue?vue&type=script&lang=js&"
import style0 from "./TheListPagination.vue?vue&type=style&index=0&id=5b85d6dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b85d6dd",
  null
  
)

export default component.exports